
// *** This file is automatically generated by git.version.ts script. Version no. is taken from package.json *** 
export const versions = {
  version: "latest",
  project_id: "project"
};
